import { Button, Flex, HStack, Icon } from "@chakra-ui/react";
import { FiArrowDown, FiArrowUp } from "react-icons/fi";
import FilterButton from "components/Button/FilterButton";
import SearchBar from "components/SearchBar";

export type AssignmentFilter = "all" | "auto" | "manual";
export type SortDirection = "desc" | "asc";

interface PathsToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  assignmentFilter: AssignmentFilter;
  onAssignmentFilterChange: (value: AssignmentFilter) => void;
  sortDirection: SortDirection;
  onSortDirectionToggle: () => void;
}

const CHIPS: Array<{ value: AssignmentFilter; label: string }> = [
  { value: "all", label: "All" },
  { value: "auto", label: "Auto-assigned" },
  { value: "manual", label: "Manual" },
];

export default function PathsToolbar({
  search,
  onSearchChange,
  assignmentFilter,
  onAssignmentFilterChange,
  sortDirection,
  onSortDirectionToggle,
}: PathsToolbarProps) {
  return (
    <Flex w="100%" align="center" gap="3" wrap="wrap">
      <SearchBar
        placeholder="Search paths"
        input={search}
        onInput={onSearchChange}
        w="260px"
        maxW="260px"
      />

      <HStack spacing="2">
        {CHIPS.map((chip) => (
          <FilterButton
            key={chip.value}
            isActive={assignmentFilter === chip.value}
            onClick={() => onAssignmentFilterChange(chip.value)}
            borderRadius="full"
          >
            {chip.label}
          </FilterButton>
        ))}
      </HStack>

      <Button
        ml="auto"
        size="sm"
        variant="ghost"
        colorScheme="gray"
        color="gray.600"
        leftIcon={<Icon as={sortDirection === "desc" ? FiArrowDown : FiArrowUp} boxSize={3.5} />}
        onClick={onSortDirectionToggle}
        aria-label={`Sort by last assigned (${sortDirection === "desc" ? "most recent first" : "oldest first"})`}
      >
        Last assigned
      </Button>
    </Flex>
  );
}
